export default "__VITE_ASSET__BR9rWZ5H__"